/* eslint-disable react/prop-types */
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { theme } from "./theme";

interface Props {
    children: React.ReactNode;
}
export const AppTheme = (props: Props) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {props.children}
        </ThemeProvider>
    );
};
